<script>
  import { focusOnInit } from './../modules/helpers.js'
  import { onMount } from 'svelte'
  export let type = 'text'
  export let name = ''
  export let value = ''
  export let autocomplete = 'off'
  export let error = false
  export let required = false
  export let disabled = false
  export let focused = false
  export let spellcheck = false
  export let placeholder = ''

  let el
  onMount(() => focused ? el.focus() : '' )
  
</script>

<input 
  bind:this={el}
  on:change
  on:focus
  on:blur
  on:input
  on:input={() => value = el.value}
  on:keydown
  type={type} 
  name={name} 
  value={value}
  placeholder={placeholder}
  autocomplete={autocomplete} 
  disabled={disabled}
  required={required}
  spellcheck={spellcheck}
  data-1p-ignore={autocomplete === 'off' ? 'true' : null}
  class:error>

<style>
  input {
    appearance: none;
    padding: 0.6rem 1rem;
    width: 100%;
    height: 4rem;
    outline: 0;
    color: var(--c-text);
    border: 1px solid var(--c-pill-bg);
    background-color: var(--c-content-bg);
    font-size: 1.5rem;
    transition-property: box-shadow, background-color, border-color;
		transition-duration: var(--transition-duration);
		transition-timing-function: var(--transition-function);
  }

  input:focus {
    box-shadow: var(--box-shadow);
    border-color: var(--c-nav-bg);
  }

  input.error {
    color: var(--c-danger);
  }
  
</style>